import './index.css'
import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import ThemeContext from '../ThemeContext'

class Login extends Component {
  state = {
    userName: '',
    password: '',
    isError: false,
    error: '',
    toshowpass: false,
  }

  toInputName = event => {
    this.setState({userName: event.target.value})
  }

  toInputPassword = event => {
    this.setState({password: event.target.value})
  }

  toFormSubmit = async event => {
    event.preventDefault()
    const {userName, password} = this.state
    const api = 'https://apis.ccbp.in/login'
    const userDetails = {
      username: userName === 'amit' ? 'rahul' : '',
      password: password === 'amit@2024' ? 'rahul@2021' : '',
    }
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch(api, options)

    const data = await response.json()

    if (response.ok) {
      const {history} = this.props
      Cookies.set('jwt_token', data.jwt_token, {expires: 30, path: '/'})
      history.replace('/')
    } else {
      console.log(data.error_msg)
      this.setState({isError: true, error: data.error_msg})
    }
  }

  toShowpassword = () => {
    this.setState(prev => ({toshowpass: !prev.toshowpass}))
  }

  render() {
    const {userName, password, isError, error, toshowpass} = this.state
    const token = Cookies.get('jwt_token')
    if (token !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <ThemeContext.Consumer>
        {value => {
          const {activeThemeIsLight} = value

          return (
            <div
              className="login_main_div"
              style={{
                backgroundColor: activeThemeIsLight ? '#ebebeb' : ' #313131',
              }}
            >
              <div
                className="login_main_div_a"
                style={{
                  backgroundColor: activeThemeIsLight ? '#f8fafc' : ' #0f0f0f',
                  color: activeThemeIsLight ? '' : 'white',
                }}
              >
                <img
                  src={
                    activeThemeIsLight
                      ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'
                      : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'
                  }
                  alt="website logo"
                  className="logo_image_login"
                />
                <form className="login_form" onSubmit={this.toFormSubmit}>
                  <label htmlFor="username">USERNAME</label>
                  <input
                    type="text"
                    id="userName"
                    value={userName}
                    onChange={this.toInputName}
                    placeholder="Username"
                  />
                  <label htmlFor="username_A">PASSWORD</label>
                  <input
                    type={toshowpass ? 'text' : 'password'}
                    id="userName_A"
                    value={password}
                    onChange={this.toInputPassword}
                    placeholder="Password"
                  />
                  <div className="to_show_password">
                    <input
                      id="checkbox"
                      type="checkbox"
                      onClick={this.toShowpassword}
                      className="checkbox"
                    />
                    <label
                      className="show"
                      htmlFor="checkbox"
                      style={{
                        color: activeThemeIsLight ? 'black' : 'white',
                      }}
                    >
                      {' '}
                      Show Password{' '}
                    </label>
                  </div>
                  <button type="submit" className="login_button">
                    Login
                  </button>
                </form>
                {isError ? <p className="error_login">*{error}</p> : null}
                <div className="user_details">
                  <p className="user_detail">
                    *use <br /> username: amit , password: amit@2024
                  </p>
                </div>
              </div>
            </div>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}
export default Login
